// src/componentes/common/BotonesAccionRapida.jsx
//
// v1.2 / S3-3: Botones de acción rápida reusables (WhatsApp, copy teléfono,
// abrir detalle de deuda/cliente). Pensado para FichaConciliador,
// SelectorClientePlan, AgendaDiaria y cualquier vista donde tener un
// "atajo a contactar" tenga sentido.

import React from "react";
import { useNavigate } from "react-router-dom";
import notify from "./notify";
import "./BotonesAccionRapida.css";

// Normaliza el teléfono a 10 dígitos (MX) — quita espacios, paréntesis, guiones
function tel10(telefono) {
  const s = String(telefono || "").replace(/\D/g, "");
  // Si ya viene con código de país (52), tómalo
  if (s.length === 12 && s.startsWith("52")) return s.slice(2);
  if (s.length === 11 && s.startsWith("1")) return s.slice(1);
  return s.slice(-10);
}

function abrirWhatsApp(telefono, mensaje = "") {
  const tel = tel10(telefono);
  if (!tel || tel.length < 10) {
    notify.error("Teléfono inválido para WhatsApp");
    return;
  }
  const url = `https://wa.me/52${tel}${mensaje ? `?text=${encodeURIComponent(mensaje)}` : ""}`;
  window.open(url, "_blank");
}

async function copiarPortapapeles(texto, etiqueta = "Teléfono") {
  if (!texto) {
    notify.error(`${etiqueta} no disponible`);
    return;
  }
  try {
    await navigator.clipboard.writeText(String(texto));
    notify.success(`${etiqueta} copiado`);
  } catch {
    notify.error("No se pudo copiar al portapapeles");
  }
}

/**
 * @param {object} props
 * @param {string} props.telefono - Número (cualquier formato)
 * @param {string} [props.mensaje] - Mensaje pre-llenado para WhatsApp
 * @param {string} [props.clienteId] - Para link de "abrir cliente"
 * @param {string} [props.deudaId] - Para link de "abrir deuda"
 * @param {"compact"|"normal"} [props.tamano="normal"]
 * @param {boolean} [props.mostrarAbrirCliente=true]
 * @param {boolean} [props.mostrarAbrirDeuda=true]
 */
const BotonesAccionRapida = ({
  telefono,
  mensaje = "",
  clienteId,
  deudaId,
  tamano = "normal",
  mostrarAbrirCliente = true,
  mostrarAbrirDeuda = true,
}) => {
  const navigate = useNavigate();
  const cls = `bar ${tamano === "compact" ? "bar-compact" : ""}`;

  const irACliente = () => {
    if (clienteId) navigate(`/app/cliente/${clienteId}`);
  };
  const irADeuda = () => {
    if (clienteId && deudaId) {
      navigate(`/app/cliente/${clienteId}/deudas/${deudaId}`);
    } else if (deudaId) {
      navigate(`/app/deudas/${deudaId}`);
    }
  };

  const telOk = tel10(telefono).length === 10;

  return (
    <div className={cls}>
      <button
        type="button"
        className="bar-btn bar-btn-wa"
        onClick={() => abrirWhatsApp(telefono, mensaje)}
        disabled={!telOk}
        title={telOk ? `WhatsApp a ${telefono}` : "Teléfono inválido"}
      >
        💬 WhatsApp
      </button>

      <button
        type="button"
        className="bar-btn bar-btn-copy"
        onClick={() => copiarPortapapeles(telefono)}
        disabled={!telOk}
        title="Copiar teléfono"
      >
        📋 Copiar tel
      </button>

      {mostrarAbrirCliente && clienteId && (
        <button
          type="button"
          className="bar-btn bar-btn-cliente"
          onClick={irACliente}
          title="Abrir cliente"
        >
          👤 Cliente
        </button>
      )}

      {mostrarAbrirDeuda && deudaId && (
        <button
          type="button"
          className="bar-btn bar-btn-deuda"
          onClick={irADeuda}
          title="Abrir detalle de deuda"
        >
          📋 Deuda
        </button>
      )}
    </div>
  );
};

export default BotonesAccionRapida;
export { tel10, abrirWhatsApp, copiarPortapapeles };
